import { GenericTable } from "../../../../../../components/GenericTable/GenericTable";
import { CertificateActions } from "../../CertificateDocs/CertificateActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { Stack } from "@mui/material";
import { isMobile } from "react-device-detect";
import { NoDataWarning } from "@/components/common";

export function NoteReport({
  rowData = [],
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  // Dados já vêm processados e filtrados do componente Documents
  // Apenas define as colunas da tabela
  const columns = [
    { column: "Profissional", rowName: "practitioner" },
    { column: "Data", rowName: "date" },
    {
      column: "Especialidade",
      rowName: "specialty",
    },
  ];

  if (isMobile) {
    return (
      <Stack spacing={2}>
        <>
          {rowData && rowData?.length > 0 ? (
            rowData?.map((row: any) => (
              <DocumentCard
                key={row.id}
                title="Relatório médico"
                date={row.date}
                practitioner={row.practitioner}
                specialty={row.specialty}
                // status={{
                //   text: "Atestado",
                //   color: "#FF9800",
                //   icon: <Description fontSize="small" />,
                // }}
                actions={
                  <CertificateActions
                    setRefetch={setRefetch}
                    row={row}
                    handleOpen={handleOpen}
                    setBinaryUrl={setBinaryUrl}
                    cardActions
                  />
                }
              />
            ))
          ) : (
            <NoDataWarning />
          )}
        </>
      </Stack>
    );
  }

  return (
    <GenericTable
      tableColumns={columns}
      tableRows={rowData}
      actions={(rowData: any) => (
        <CertificateActions
          setRefetch={setRefetch}
          row={rowData}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
    />
  );
}
